// extracted by css-extract-rspack-plugin
export default {"brand":"Logo__brand--V3Cg5"};